import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import { changeVehicle } from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let address = eachitem.address;
      let groups = eachitem.groups;
      let chassino = eachitem.chassino;
      let lastcomm = moment(eachitem.lastcomm).format(dateFormat);
      let model = eachitem.model;
      let timestamp = moment(eachitem.timestamp).format(dateFormat);
      let lat = eachitem.lat;
      let lng = eachitem.lng;
      historyData.push({
        vehicleno,
        address,
        groups,
        chassino,
        lastcomm,
        model,
        timestamp,
        lat,
        lng,
      });
    }
  }
  callback(historyData);
};
const getHistory = (schema, data, store) => {
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let saveState = null;
  let tableStateData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 7) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 7 days",
        content: "You can't select date range of more than 7 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    let vehicleIds = data.vehicle.map((vehicle) => {
      return vehicle.id;
    });
    let body = {
      vehicleid: vehicleIds,
      starttime: starttime,
      endtime: endtime,
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }

    ReportAPIs.getBlrPoliceLocation(body)
      .then((resp) => {
        window.dataForAll = resp;
        window.dataForAll = resp;
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        processData(resp, store.vehicleMap, (data) => {
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          if (schema.content[0].ref) {
            schema.content[0].ref.setData(data);
          }
        });
      })
      .catch(() => {
        console.log("something went wrong");
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        schema.content[0].ref.setBusy(false);
      });
  }
};
const download = (schema) => {
  if (schema.content[0].ref) {
    JSONToCSVConvertor(
      schema.content[0].ref.getData(true),
      "Peak Time Report",
      false
    );
  }
};
const schema = {
  key: "peak_hour_report",
  name: "Peak",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount: 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      // hideTime: true,
      schemaKey: "peak_hour_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      // hideTime: true,
      schemaKey: "peak_hour_report",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Peak Time Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "Vehicle No" },
        { key: "groups", name: "Groups" },
        { key: "chassino", name: "ChassiNo" },
        { key: "timestamp", name: "Peak Time" },
        { key: "model", name: "Model" },
        { key: "lastcomm", name: "Last Comm Time" },
        {
          key: "address",
          name: "Address",
          onClick: (data, item) => {
            window.showInGoogleMaps(item.lat, item.lng);
          },
        },
      ],
    },
  ],
};
export default schema;
